export const readArray = (value) => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.data)) return value.data;
  if (Array.isArray(value?.result)) return value.result;
  if (Array.isArray(value?.items)) return value.items;
  return [];
};

export const pickVal = (obj = {}, keys = []) => {
  for (const key of keys) {
    if (obj?.[key] !== undefined && obj?.[key] !== null) return obj[key];
    const fallback = Object.keys(obj || {}).find(
      (k) => k.toLowerCase() === String(key).toLowerCase(),
    );
    if (fallback && obj[fallback] !== undefined && obj[fallback] !== null) {
      return obj[fallback];
    }
  }
  return "";
};

export const parseCsv = (value = "") =>
  String(value || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

export const stringifyArray = (arr = []) => arr.join(",");